var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgApproveConfirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.161,
    height: 71.812,
    viewBox: "0 0 90.161 71.812"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-approve-confirm_svg__cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:1.6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-approve-confirm_svg__ICN_Modal_confirmare_Aproba_Enabled",
    "data-name": "ICN_Modal confirmare Aproba_Enabled",
    transform: "translate(-942.919 -396.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-approve-confirm_svg__Path_948",
    d: "M44.5 13.39a4 4 0 016.929 0l41.11 63.81a4 4 0 01-3.465 6H6.926a4 4 0 01-3.465-6z",
    "data-name": "Path 948",
    transform: "translate(940 385)",
    fill: "#43b02a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-approve-confirm_svg__ICN_Aproba_Enabled",
    transform: "translate(788 168.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-approve-confirm_svg__Path_972",
    "data-name": "Path 972",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.915 0A12.915 12.915 0 110 12.915 12.915 12.915 0 0112.915 0z",
    transform: "translate(187 260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.915 1.6a11.24 11.24 0 00-8 3.314A11.24 11.24 0 001.6 12.915a11.24 11.24 0 003.314 8 11.24 11.24 0 008.001 3.315 11.24 11.24 0 008-3.314 11.24 11.24 0 003.315-8.001 11.24 11.24 0 00-3.314-8A11.24 11.24 0 0012.915 1.6m0-1.6C20.048 0 25.83 5.782 25.83 12.915c0 7.133-5.782 12.915-12.915 12.915C5.782 25.83 0 20.048 0 12.915 0 5.782 5.782 0 12.915 0z",
    transform: "translate(187 260)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-approve-confirm_svg__ICN_Inchide_Sertar_Detalii_Enabled",
    "data-name": "ICN_Inchide Sertar Detalii_Enabled",
    transform: "translate(193.837 269.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-approve-confirm_svg__Line_276",
    d: "M0 0l4.558 4.558",
    className: "kpmg-approve-confirm_svg__cls-3",
    "data-name": "Line 276",
    transform: "translate(0 3.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-approve-confirm_svg__Line_277",
    d: "M0 7.597L7.597 0",
    className: "kpmg-approve-confirm_svg__cls-3",
    "data-name": "Line 277",
    transform: "translate(4.558)"
  }))))));
}

export default SvgKpmgApproveConfirm;